/* eslint-disable import/order */
import React from 'react';
import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { embeddedIssuePreloadLayoutBuilder } from '@jira/platform__layouts-issue-preload-layout/src/index.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { horizontalNavJiraResource } from '@jira/navigation-apps__resources/src/controllers/horizontal-navigation/horizontal-nav-jira/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { nextGenRoadmapResource } from '@jira/router-resources__roadmap/src/nextGenRoadmapResource.tsx';
import { softwareRoadmapRoute } from '@jira/router-routes__software-roadmap-routes/src/softwareRoadmapRoute.tsx';

import { RoadmapSkeleton } from '@jira/platform__skeletons/src/ui/roadmap/RoadmapSkeleton.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { softwareProjectLayoutCode } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { Redirect, type Route, type RouteContext } from '@atlassian/react-resource-router';
import { LazyNextGenRoadmap } from './ui/index.tsx';

const SoftwareTimelineRedirect = ({
	match: {
		params: { projectKey, boardId },
	},
	query,
}: RouteContext) => {
	const queryParams = new URLSearchParams(query).toString();

	return (
		<Redirect
			to={{
				pathname: `/jira/software/projects/${String(projectKey)}/boards/${String(
					boardId,
				)}/timeline`,
				hash: '',
				search: queryParams,
			}}
		/>
	);
};

export const softwareRoadmapRouteEntry: Route = createEntry(softwareRoadmapRoute, () => ({
	group: 'software',
	// eslint-disable-next-line no-restricted-syntax
	component: SoftwareTimelineRedirect,
	skeleton: RoadmapSkeleton,

	layout: composeLayouts(
		softwareProjectLayoutCode,
		embeddedIssuePreloadLayoutBuilder([{ query: ['selectedIssue'] }]),
	),

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
	},

	resources: [
		...getNavigationResources(),
		...getIssueViewResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		projectContextResource,
		staticProjectSidebarNavigationResource,
		horizontalNavJiraResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		nextGenRoadmapResource,
	],

	preloadOptions: {
		earlyChunks: ['software-roadmap-early-entry'],
	},

	afterPaint: [LazyIssueApp],
	forPaint: [LazyAtlassianNavigation, LazyNextGenRoadmap],
	ufoName: 'next-gen-roadmap',
	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
